export default __webpack_public_path__ + "static/media/money.59570150.svg";